// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1fhhi","approved":"Status_approved__3-5p3","rejected":"Status_rejected__2FMsd","expired":"Status_expired__1fUUi","label":"Status_label__3Nbqr"};